import { useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';
import { useLingui } from '@lingui/react';

const STORAGE_KEY = 'theme';

/**
 * Dark/light tema geçişini yönetir.
 * Seçim localStorage'a kaydedilir ve sayfa yenilenmesinde korunur.
 */
export function ThemeToggle() {
  const { _ } = useLingui();
  const [isDark, setIsDark] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'dark';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
    try {
      localStorage.setItem(STORAGE_KEY, isDark ? 'dark' : 'light');
    } catch {
      // ignore
    }
  }, [isDark]);

  return (
    <button
      className="btn btn-ghost btn-circle text-base-content"
      onClick={() => setIsDark((prev) => !prev)}
      title={
        isDark ? _({ id: 'layout.themeToggle.toLight' }) : _({ id: 'layout.themeToggle.toDark' })
      }
      aria-label={
        isDark ? _({ id: 'layout.themeToggle.toLight' }) : _({ id: 'layout.themeToggle.toDark' })
      }
    >
      {isDark ? (
        <Sun
          size={18}
          strokeWidth={2.25}
          className="shrink-0 text-base-content"
          aria-hidden="true"
        />
      ) : (
        <Moon
          size={18}
          strokeWidth={2.25}
          className="shrink-0 text-base-content"
          aria-hidden="true"
        />
      )}
    </button>
  );
}
